/**
 * Дедуп уведомлений о заказах (сокет + poll).
 * @param maxSize — максимум id в Set (FIFO-очистка старше)
 */
export const createNewOrderNotifyDedupe = (maxSize = 200) => {
  const notifiedOrderIds = new Set<number>()
  const notifiedOrderIdQueue: number[] = []
  let seenLatestId = 0

  const remember = (orderId: number): void => {
    if (notifiedOrderIds.has(orderId)) {
      return
    }
    notifiedOrderIds.add(orderId)
    notifiedOrderIdQueue.push(orderId)
    while (notifiedOrderIdQueue.length > maxSize) {
      const oldestOrderId = notifiedOrderIdQueue.shift()
      if (oldestOrderId != null) {
        notifiedOrderIds.delete(oldestOrderId)
      }
    }
    if (orderId > seenLatestId) {
      seenLatestId = orderId
    }
  }

  return {
    has: (orderId: number) => notifiedOrderIds.has(orderId),
    remember,
    getSeenLatestId: () => seenLatestId,
    setSeenLatestId: (orderId: number) => {
      seenLatestId = orderId
    },
  }
}
